import { createApp } from "vue";
import App from "./App.vue";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import tailpieces from "tailpieces";
const app = createApp(App);
import "./style.css";
import { getEnv } from "@/utils";
app.use(tailpieces);
app.use(VueGoogleMaps, {
  load: {
    key: getEnv("VUE_APP_MAP_API_KEY"),
    libraries: ["places"],
    language: "pt_BR",
  },
});
app.mount("#app");
